import type { Dispatch } from 'react';
import { type BotMode, BotModeSection } from '../tenant-sections/BotModeSection';
import type { WizardAction, WizardDraft } from './types';

/** Paso 5 del wizard = la sección Modo del bot montada en modo wizard. */
export function Step5BotMode({
  draft,
  dispatch,
}: {
  draft: WizardDraft;
  dispatch: Dispatch<WizardAction>;
}) {
  return (
    <BotModeSection
      mode="wizard"
      testId="wizard-step-5"
      tenantId={draft?.tenantId ?? ''}
      value={draft?.botMode ?? null}
      onSaved={(patch) => {
        dispatch({ type: 'set-bot-mode', botMode: patch as BotMode });
        dispatch({ type: 'goto', step: 6 });
      }}
    />
  );
}
